import { render, staticRenderFns } from "./appSubscription.vue?vue&type=template&id=0960364d&"
import script from "./appSubscription.vue?vue&type=script&lang=js&"
export * from "./appSubscription.vue?vue&type=script&lang=js&"
import style0 from "./appSubscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports